import { useState } from 'react';

import PersonNcsaOptInData from './PersonNcsaOptInData';

const usePersonNcsaOptInData = () => {
  const [ personNcsaOptInState, setPersonNcsaOptInState ] = useState({...PersonNcsaOptInData.INITIAL_STATE});

  const postPersonNcsaOptIn = (postObj) => {
    return PersonNcsaOptInData.postPersonNcsaOptIn(postObj, personNcsaOptInState, setPersonNcsaOptInState);
  };

  return {
    personNcsaOptInState,
    postPersonNcsaOptIn,
  };
}

export default usePersonNcsaOptInData;